import { Badge } from '../../../components/ui';
import { useT } from '../../../i18n';
import { TRANG_THAI_PHIEN_BAN } from '../constants';
import type { TrangThaiPhienBan } from '../types';

export function BadgeTrangThaiPhienBan({ trangThai }: { trangThai: TrangThaiPhienBan }) {
  const { t } = useT();
  const cauHinh = TRANG_THAI_PHIEN_BAN[trangThai];
  return <Badge variant={cauHinh.variant}>{t(cauHinh.khoa)}</Badge>;
}
